export default "__VITE_ASSET__CAuj8rPd__"